<template>
  <div>
    <customer-header/>

    <!-- 콘텐츠 영역 -->
    <div id="container" class="container">
      <!-- service -->
      <main class="service" id="contents">
        <!-- top -->
        <div class="top-contents company-top-contents">
          <div class="wrap">
            <h1 class="cp-h1" tabindex="0">JUST DIVE!<br>콘텐츠웨이브</h1>
          </div>
        </div>
        <!--// top -->

        <!-- sticky nav -->
        <div id="sticky-menu" class="sticky-navigation">
          <ul>
            <li>
              <a href="#i-sec01" v-smooth-scroll="{offset:-64}" class="scroll on">회사소개</a>
            </li>
            <li>
              <a href="#i-sec02" v-smooth-scroll="{offset:-64}" class="scroll">연혁</a>
            </li>
            <li>
              <a href="#i-sec03" v-smooth-scroll="{offset:-64}" class="scroll">BI</a>
            </li>
            <li>
              <a href="#i-sec04" v-smooth-scroll="{offset:-64}" class="scroll">Award</a>
            </li>
            <li>
              <a href="#i-sec05" v-smooth-scroll="{offset:-64}" class="scroll">오시는 길</a>
            </li>
          </ul>
        </div>
        <!--// sticky nav -->

        <div class="contents-wrap">
          <!-- info 01 -->
          <section id="i-sec01">
            <div class="info-sec01 tAc">
              <div class="if-wrap">
                <h2 class="title" tabindex="0">프리미엄 콘텐츠 포털, Wavve!</h2>
                <p class="title-txt" tabindex="0">
                  국내외 프리미엄 채널과 VOD를 무제한 즐길 수 있어요.
                </p>
                <img src="../../assets/images/service/info-sec01-img.png" class="img-channels" alt="KBS, MBC, SBS를 포함한 국내외 프리미엄 채널"/>
                <h2 class="title" tabindex="0">사업영역</h2>
                <ul class="i-sec01-list" tabindex="0">
                  <li>
                    <img src="../../assets/images/service/i-sec01-img02.png" alt="N-스크린 기반 콘텐츠 서비스">
                    <p>N-스크린 기반</p>
                    <strong>콘텐츠 서비스</strong>
                  </li>
                  <li>
                    <img src="../../assets/images/service/i-sec01-img03.png" alt="프로그램 제작투자 오리지널 콘텐츠">
                    <p>프로그램 제작투자</p>
                    <strong>오리지널 콘텐츠</strong>
                  </li>
                  <li>
                    <img src="../../assets/images/service/i-sec01-img04.png" alt="한류 콘텐츠 기반 글로벌 OTT 사업">
                    <p>한류 콘텐츠 기반</p>
                    <strong>글로벌 OTT 사업</strong>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <!--// info 01 -->

          <!-- info 02 -->
          <section id="i-sec02">
            <div class="info-sec02 tAc">
              <h2 class="title fc-white" tabindex="0">연혁</h2>
              <!-- slider -->
              <div class="swiper-wrap">
                <div id="swiper-container" class="swiper-container i02-slider swiper-container-horizontal">
                  <!-- Additional required wrapper -->
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2012 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>콘텐츠연합플랫폼 설립(MBC/SBS 공동) <span class="history-month">05</span></li>
                              <li>POOQ서비스 오픈 <span class="history-month">07</span></li>
                              <li>유료서비스 개시 <span class="history-month">09</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle bg-before-none">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2012</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2013 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>삼성/LG 스마트 TV제휴 <span class="history-month">02</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2013</span>
                        </div>
                      </div>
                    </div>

                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2014 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>아시안게임 모바일 독점 서비스 <span class="history-month">09</span></li>
                              <li>유상증자(KBS지분참여) <span class="history-month">12</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2014</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2015 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>POOQ 2.0 서비스 <span class="history-month">06</span></li>
                              <li>영화서비스</li>
                              <li>초고화질(5M) 서비스</li>
                              <li>프리미어12 독점중계 <span class="history-month">11</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2015</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2016 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>방송+영화 슈퍼팩 <span class="history-month">01</span></li>
                              <li>구글캐스트 지원 <span class="history-month">02</span></li>
                              <li>리우올림픽 중계 <span class="history-month">08</span></li>
                              <li>B2B &lt;푹존&gt; 서비스 <span class="history-month">09</span></li>
                              <li>Quick VOD 서비스 <span class="history-month">09</span></li>
                              <li>유료가입자 50만명 돌파 <span class="history-month">10</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2016</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2017 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>방송+음악 결합상품 <span class="history-month">04</span></li>
                              <li>실시간TV 무료 <span class="history-month">07</span></li>
                              <li>UHD 서비스(TIVIVA) <span class="history-month">11</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2017</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2018 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>평창 동계올림픽 중계 <span class="history-month">02</span></li>
                              <li>POOQ 3.0 서비스 <span class="history-month">04</span></li>
                              <li>러시아 월드컵 중계 <span class="history-month">06</span></li>
                              <li>아시안게임 중계 <span class="history-month">08</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2018</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2019 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>Wavve 런칭 <span class="history-month">09</span></li>
                              <li>유상증자(SKT 지분참여)</li>
                              <li>사명변경(콘텐츠웨이브)</li>
                              <li>프리미어 12 독점중계 <span class="history-month">11</span></li>
                              <li>재무투자(2천억원) 유치 <span class="history-month">11</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2019</span>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="history-list-wrap">
                        <h3 class="a11y-hidden" tabindex="0">2020 history</h3>
                        <div class="history-list-box" tabindex="0">
                          <div class="history-list-inner-box">
                            <ul>
                              <li>웨이브 전용 카드 출시 <span class="history-month">06</span></li>
                              <li>음악(FLO)결합상품 출시 <span class="history-month">07</span></li>
                            </ul>
                            <span class="history-txt">History</span>
                          </div>
                        </div>
                        <div class="history-year-box">
                          <span class="history-circle bg-after-none">
                              <img src="../../assets/images/service/i-history-dot.png" alt="">
                          </span>
                          <span class="history-year">2020</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="i02-slider-btn swiper-button-prev"></div>
                <div class="i02-slider-btn swiper-button-next"></div>
              </div>
              <!--// slider -->

            </div>
          </section>
          <!--// info 02 -->

          <!-- info 03 -->
          <section id="i-sec03">
            <div class="info-sec03 tAc">
              <div class="if-wrap">
                <h2 class="title" tabindex="0">BI</h2>
                <div class="i-sec03-txt">
                  <div class="txt-type01">
                    <img src="../../assets/images/service/i-sec03-img.png" alt="Wavve BI">
                  </div>
                  <div class="txt-type02">
                    <strong>JUST DIVE!</strong>
                    <p tabindex="0">
                      웨이브 로고는 ‘파도’의 움직임을 형상화한 둥근 곡선과 강렬한 볼드 타입 디자인으로 부드러움과 강렬한 이미지를 담았습니다.<br><br>
                      슬로건 ‘JUST DIVE’는 웨이브가 이용자 일상의 모든 시간을 함께하며 더 많은 즐거움을 제공하겠다는 의지를 담았습니다. ‘JUST’는 부담 없이 가볍게 즐길 수 있는 콘텐츠를, ‘DIVE’는 몰입해서 푹 빠져 볼 수 있는 콘텐츠를 의미합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!--// info 03 -->

          <!-- info 03 -->
          <section id="i-sec04">
            <div class="info-sec04">
              <div class="if-wrap">
                <h2 class="title tAc" tabindex="0">Award</h2>
                <ul class="i-sec04-list" tabindex="0">
                  <li>THE PRIDE OF KOREA, BRAND, KOREA MARKETING AWARDS</li>
                  <li>15th KOREA ASSEMBLY GRAND AWARD</li>
                </ul>
                <div class="i-sec04-txt" tabindex="0">
                  <p class="company-dot-text"><span>2017 대한민국디지털브랜드대상 - 2017 가장 추천하고 싶은 100대 어플(The Most Recommended Application)</span></p>
                  <p class="company-dot-text"><span>2017 애플 – 올해의 인기 앱(아이패드 무료 앱 기준)</span></p>
                  <p class="company-dot-text"><span>2017 앱애니 – 상반기 앱 매출 1위</span></p>
                  <p class="company-dot-text"><span>2016 닐슨코리안클릭 – 앱 평균 사용시간 1위</span></p>
                  <p class="company-dot-text"><span>2016 서비스 브랜드 인덱스(한국갤럽) – 동영상앱 사용빈도 1위</span></p>
                  <p class="company-dot-text"><span>2016 제15회 대한민국 국회대상 - 뉴미디어 플랫폼부문</span></p>
                </div>
              </div>
            </div>
          </section>
          <!--// info 03 -->

          <!-- info 05 -->
          <section id="i-sec05">
            <div class="info-sec05">
              <div class="if-wrap">
                <h2 class="title tAc" tabindex="0">오시는 길</h2>
                <!-- map -->
                <div class="embed-container">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.390506545792!2d126.92405035135413!3d37.52229097970703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9f7c70ce6085%3A0x5c01aec6e7375d1d!2z7Jes7J2Y64-EIO2PrOyKpO2KuCDtg4Dsm4wuIOyXrOydmOuPhOyasOyytOq1rQ!5e0!3m2!1sko!2skr!4v1613976412803!5m2!1sko!2skr" height="450" allowfullscreen=""></iframe>
                </div>
                <!--// map -->
                <table class="i-sec05-txt">
                  <colgroup>
                    <col style="width: 150px;">
                    <col>
                  </colgroup>
                  <tbody>
                  <tr>
                    <th tabindex="0">
                      주소
                    </th>
                    <td tabindex="0">
                      서울특별시 영등포구 여의나루로 60 포스트타워 19층
                    </td>
                  </tr>
                  <tr>
                    <th tabindex="0">
                      찾아오시는 방법
                    </th>
                    <td tabindex="0">
                      5호선/9호선 여의도역 5번 출구
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
        <!--// info 05 -->
      </main>
      <!--// service -->
    </div>
    <footer-info />
  </div>
</template>

<script>
import Swiper from '@/mixins/swiper'
import { customerSubMenuScrollEvent, titleTagNameChange } from '@/common/utils/common'
import _ from 'lodash'
import FooterInfo from '@/components/common/footer/FooterInfo'
import CustomerHeader from '@/components/common/header/CustomerHeader'
export default {
  components: { FooterInfo, CustomerHeader },
  mixins: [
    Swiper
  ],
  data () {
    return {
      sticky: false,
      contentElList: [],
      subMenuElList: [],
      subMenuContentElList: [],
      stickyMenuEl: {},
      stickyMenuElInitOffset: 0,
      swiperOptions: {
        initialSlide: 2,
        slidesPerView: 5,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.swiperElement = '#swiper-container'
      this.isReady = true
      this.stickyMenuElInitOffset = document.getElementById('sticky-menu').offsetTop
      titleTagNameChange('회사소개 : 웨이브')
    })
  },
  methods: {
    scrollThrottleEvent: _.throttle(function () {
      customerSubMenuScrollEvent(this.stickyMenuEl, this.contentElList, this.subMenuElList, this.stickyMenuElInitOffset)
    }, 150)
  },
  mounted () {
    this.contentElList = document.querySelectorAll('section[id^=i-sec]')
    this.stickyMenuEl = document.getElementById('sticky-menu')
    this.subMenuElList = document.querySelectorAll('#sticky-menu li a')
    window.addEventListener('scroll', this.scrollThrottleEvent)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollThrottleEvent)
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
